import { useNavigate } from '@tanstack/react-router';
import { CircleArrowLeft, Loader2 } from 'lucide-react';

import { useGetLoginImageQuery } from '~entities/studios/api/get-login-image';
import { useGetStudioDetailsWithImage } from '~entities/studios/api/get-studio-details-with-image';

import { Button } from '~shared/shadcn/ui/button';

import { EditParentPortalButton } from './edit-parent-portal-button';
import { LoginImageForm } from './login-image-form';
import { StudioProfileForm } from './studio-profile-form';

export function StudioProfilePage() {
  const navigate = useNavigate();
  const { data, isFetching } = useGetStudioDetailsWithImage();
  const { data: loginImageData, isFetching: isLoginImageFetching } =
    useGetLoginImageQuery(data?.locationId ?? '');

  return (
    <>
      <div className='mb-6 flex min-w-0 flex-wrap items-center gap-2 sm:mb-8'>
        <Button
          variant={'ghost'}
          className='flex items-center p-2 [&_svg]:size-6'
          onClick={() => {
            void navigate({
              to: '/dashboard',
            });
          }}
        >
          <CircleArrowLeft className='size-6' />
        </Button>
        <h2 className='min-w-0 flex-1 text-xl font-semibold sm:text-2xl'>
          Studio Profile
        </h2>
        <EditParentPortalButton locationId={data?.locationId} />
      </div>
      <div className='mx-auto min-w-0 px-0 py-4 sm:px-4 sm:py-10'>
        <div className='mx-auto flex max-w-[100%] flex-col gap-8 sm:gap-10 lg:flex-row lg:flex-wrap'>
          {isFetching ? (
            <div>
              <Loader2 className='size-6 animate-spin' />
            </div>
          ) : (
            <>
              <StudioProfileForm
                currentUrl={
                  data?.imageUrl ??
                  'https://storage.googleapis.com/studio-class-default-images/upload_logo.jpeg'
                }
              />
              {isLoginImageFetching ? (
                <div>
                  <Loader2 className='size-6 animate-spin' />
                </div>
              ) : (
                <LoginImageForm
                  currentUrl={loginImageData?.imageUrl}
                  isEnabled={loginImageData?.enabled}
                />
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}
